// projects/humanresources-personnel/src/assets/i18n/*/hr-per-telephone.json
export class HrPerTelephoneKey {
    private static readonly keyPrefix = 'hrPerTelephone';
    public static title = `${HrPerTelephoneKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerTelephoneKey.keyPrefix}.pageHeader`;
    public static internalNumber = `${HrPerTelephoneKey.keyPrefix}.internalNumber`;
    public static value = `${HrPerTelephoneKey.keyPrefix}.value`;
}
